import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
import { Props } from './SocialButtonGoogle';

type StateProps = Pick<Props, 'clientId'>;
type DispatchProps = Pick<Props, 'attemptSocialLogin'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  clientId: getPublicSession(state).appIds?.googleClientId || '',
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  attemptSocialLogin,
};

export default connect(mapStateToProps, mapDispatchToProps);
